import ApplicationController from './application'

export default class extends ApplicationController {
  static targets = ['tab', 'panel']
  static values = { active: { type: String, default: 'list' } }

  connect() {
    this.showTab(this.activeValue)
  }

  switch(event) {
    event.preventDefault()
    const tab = event.currentTarget.dataset.tab
    this.activeValue = tab
    this.showTab(tab)
  }

  showTab(tabName) {
    // Update tab buttons
    this.tabTargets.forEach(tab => {
      if (tab.dataset.tab === tabName) {
        tab.classList.add('border-primary-500', 'text-primary-600')
        tab.classList.remove('border-transparent', 'text-gray-500', 'hover:border-gray-300', 'hover:text-gray-700')
      } else {
        tab.classList.remove('border-primary-500', 'text-primary-600')
        tab.classList.add('border-transparent', 'text-gray-500', 'hover:border-gray-300', 'hover:text-gray-700')
      }
    })

    // Update panels
    this.panelTargets.forEach(panel => {
      if (panel.dataset.panel === tabName) {
        panel.classList.remove('hidden')
      } else {
        panel.classList.add('hidden')
      }
    })
  }
}
